import { RequestItem, ResponseItem } from '@app/src/types/resourceExplorer'

const translateOptionsToCurrentLanguage = (previousAnswer: ResponseItem, requestItem: RequestItem) => {
  const requestCollectionItems = requestItem.requestCollection?.items
  if (!previousAnswer.selectedOptions?.length || !requestCollectionItems) return previousAnswer

  const translatedOptions = previousAnswer.selectedOptions.map(
    option => requestCollectionItems.find(it => it.value === option)?.displayText ?? option,
  )
  return { ...previousAnswer, selectedOptions: translatedOptions }
}

export default translateOptionsToCurrentLanguage
